<template>
  <!-- 天赋技能数据 -->
  <div class="talent-skill">
    <template v-if="dataSource.desc.value.trim() || dataSource.name.value.trim()">
      <div class="bar">
        <div class="left">
          <img class="icon" alt="" :src="dataSource.icon.value" />
          <div class="name">天赋：{{ dataSource.name.value }}</div>
        </div>
        <div class="right">
          <div class="upgrade" @click="handleOpenMore">升级效果</div>
          <!-- 显示升级效果 -->
          <el-dialog
            title=""
            custom-class="more-drawer"
            :visible.sync="drawer"
            :after-close="handleCloseMore"
            width="436px"
            append-to-body
          >
            <div class="more-content">
              <div class="header">
                <div class="title">天赋强化效果</div>
                <div class="close">
                  <img src="@/assets/zs_imgs/close-icon.png" alt="" @click="handleCloseMore" />
                </div>
              </div>
              <div class="content">
                <div class="list">
                  <template v-for="key in Object.keys(dataSource.upgrade)">
                    <div class="item" :key="key" v-if="dataSource.upgrade[key].desc.value">
                      <div class="level">
                        <img class="icon" alt="" :src="dataSource.upgrade[key].icon.value" />
                        <span>{{ dataSource.upgrade[key].name.value }}</span>
                      </div>
                      <div class="desc">
                        {{ dataSource.upgrade[key].desc.value }}
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
      <div class="data">
        {{ dataSource.desc.value }}
      </div>
    </template>
    <template v-else>
      <div class="empty-box">该角色暂无天赋</div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  inject: {
    refreshMap: {
      default: () => {}
    }
  },
  data() {
    return {
      drawer: false
    };
  },
  methods: {
    handleOpenMore() {
      this.drawer = true;
      this.$nextTick(() => {
        if (this.refreshMap) this.refreshMap();
      });
    },
    handleCloseMore() {
      this.drawer = false;
    }
  }
};
</script>

<style lang="less" scoped>
.talent-skill {
  width: 100%;
  margin-bottom: 18px;
  .empty-box {
    width: 100%;
    height: 73px;
    background: rgba(49, 49, 49, 0.3);
    border-radius: 8px;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    line-height: 73px;
    text-align: center;
  }
  .bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .left {
      display: flex;
      align-items: center;
    }

    .icon {
      width: 28px;
      height: 28px;
      border-radius: 4px;
      margin-right: 10px;
    }

    .name {
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 15px;
    }

    .upgrade {
      height: 20px;
      background: rgba(123, 213, 255, 0.3);
      border-radius: 10px;
      font-weight: 400;
      font-size: 11px;
      color: #82fff8;
      text-align: center;
      cursor: pointer;
      padding: 4px 10px;
      display: flex;
      align-items: center;
    }
  }
  .data {
    font-weight: 400;
    font-size: 12px;
    color: #a6a6a6;
    line-height: 16px;
  }
}
/deep/ .more-drawer {
  background: transparent;
  box-shadow: none;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    background: transparent;
  }
  .more-content {
    position: relative;
    height: 100%;
    background: url("~@/assets/zs_imgs/dialog-bg.png") no-repeat;
    background-size: 100% 100%;
    padding: 60px 17px 16px 21px;
    .header {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      padding: 24px 10px;
      .title {
        font-weight: 400;
        font-size: 16px;
        color: #fffefe;
        background: url("~@/assets/zs_imgs/dialog-title-bg.png") no-repeat;
        background-size: 152px 38px;
        width: 152px;
        height: 38px;
        line-height: 38px;
        padding-left: 22px;
      }

      .close {
        position: absolute;
        right: 22px;
        top: 30px;
        width: 18px;
        height: 18px;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
    }

    .content {
      padding-top: 25px;
      .list {
        .item {
          display: flex;
          align-items: center;
          padding: 15px 10px;
          gap: 45px;
          .level {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            gap: 11px;
            font-weight: 600;
            font-size: 12px;
            color: #ffffff;
            line-height: 16px;
            .icon {
              width: 22px;
              height: 22px;
            }
          }

          .desc {
            flex: 1;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 14px;
          }
        }
      }
    }
  }
}
</style>
